import { CollateralHistoryDetailRecord } from '@tassat/fred-definitions';
import { SecurityCurrencyAssetPair } from '@tassat/fred-extended-definitions';
import { stripPrefix } from '@tassat/utility';

import { IReclaimFormErrors, IReclaimFormValues } from './types';

export const validateReclaim = async (
    values: IReclaimFormValues,
    opts: {
        errors: IReclaimFormErrors;
        pledgeAvailableAssetAmount: CollateralHistoryDetailRecord['AssetAmount'];
        assetPair?: SecurityCurrencyAssetPair;
    }
): Promise<IReclaimFormErrors> => {
    const { errors, pledgeAvailableAssetAmount, assetPair } = opts;

    const realAssetAmount = Number(stripPrefix(values.AssetAmount, `${assetPair?.security?.Ticker} `)
        .replace(/,/g, ''));

        const availableAmount = pledgeAvailableAssetAmount ? parseFloat(pledgeAvailableAssetAmount) : 0;
        if (!realAssetAmount) {
            errors.AssetAmount = 'Please enter an amount to reclaim';
        } else if (realAssetAmount > availableAmount) {
            errors.AssetAmount = `Amount must not exceed the available ${assetPair?.security?.Ticker ?? ''} balance of the post`;
        }

    return errors;
};